export default __webpack_public_path__ + "static/media/Group 5184.594c48fd.svg";